import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import Tooltip from "../Tooltip";

export const EditButton = (props) => {
  const { t } = useTranslation();
  const { disabled = false, onClick, className, stopPropagation, href, ...rest } = props;

  const onBtnClick = (e) => {
    e.preventDefault();

    if (stopPropagation) {
      e.stopPropagation();
    }

    if (disabled) {
      return;
    }

    onClick?.();
  };

  const onNavLinkClick = (e) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  return (
    <Tooltip title={t("container.general_words.edit")} placement="top" {...rest}>
      {href ? (
        <NavLink
          to={href}
          disabled={disabled}
          onClick={onNavLinkClick}
          className={classNames("text-primary", className)}
        >
          <i className="ti-pencil-alt" />
        </NavLink>
      ) : (
        <button
          type="button"
          disabled={disabled}
          onClick={onBtnClick}
          className={classNames("text-primary", className)}
          style={{ background: "none", border: "none", padding: 0, cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <i className="ti-pencil-alt" />
        </button>
      )}
    </Tooltip>
  );
};
